import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.4",
  "description": "실험적 Boundaries, 터미널 UI 개선, 실험적 Watch Mode 캐싱 등.",
  "date": "2025/1/31",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.4는 저장소를 향상시키는 여러 개선 사항을 포함합니다:"
  }, {
    "heading": "",
    "content": "Boundaries Experimental: Turborepo의 Boundaries 첫 번째 살펴보기"
  }, {
    "heading": "",
    "content": "터미널 UI 개선: 지속적인 기본 설정 및 새로운 기능"
  }, {
    "heading": "",
    "content": "Watch Mode 캐싱 Experimental: Watch Mode에서 더 빠르게 개발"
  }, {
    "heading": "",
    "content": "순환 의존성 권장 사항: 대규모 저장소에서 Turborepo를 더 쉽게 채택"
  }, {
    "heading": "",
    "content": "node_modules의 schema.json: 저장소 내에서 버전화된 구성 유효성 검사"
  }, {
    "heading": "",
    "content": "ESLint Flat Config 지원: ESLint v9용으로 업데이트된 eslint-config-turbo 및 eslint-plugin-turbo"
  }, {
    "heading": "",
    "content": "npx @turbo/codemod migrate를 실행하여 지금 업그레이드하거나 npx create-turbo@latest로 시작하세요."
  }, {
    "heading": "boundaries-experimental",
    "content": "Turborepo는 패키지 관리자 Workspaces 위에 구축되어 저장소의 작업 캐싱을 결정하는 일부로 생태계 규칙에 의존합니다. 그러나 이를 위해서는 저장소의 모든 개발자가 이러한 규칙을 알고 준수해야 합니다."
  }, {
    "heading": "boundaries-experimental",
    "content": "Boundaries는 이러한 모범 사례가 따라지지 않는 저장소의 위치를 포착하는 실험적 기능입니다. 이를 통해 캐싱이 더 안전해지고 저장소가 향후 Turborepo 기능을 안전하게 사용할 준비가 되도록 보장합니다."
  }, {
    "heading": "boundaries-experimental",
    "content": "다음을 사용하여 오늘 시도해 보세요:"
  }, {
    "heading": "boundaries-experimental",
    "content": "Boundaries의 이 초기 반복에는 두 가지 유형의 monorepo 실수를 찾는 것이 포함됩니다:"
  }, {
    "heading": "boundaries-experimental",
    "content": "패키지 디렉토리 외부의 파일 가져오기"
  }, {
    "heading": "boundaries-experimental",
    "content": "의존성에 지정되지 않은 패키지 가져오기"
  }, {
    "heading": "boundaries-experimental",
    "content": "이러한 내장 진단뿐만 아니라 사용자 정의 Boundaries에 대한 제안이 포함된\nBoundaries RFC에 대한\n여러분의 피드백을 기대합니다."
  }, {
    "heading": "boundaries-experimental",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "터미널-ui-개선",
    "content": "Turborepo 2.0에서 처음 출시된 터미널 UI를 계속 반복 개선했습니다."
  }, {
    "heading": "지속적인-기본-설정",
    "content": "이전 버전의 Turborepo에서는 turbo를 실행할 때마다 터미널 UI를 원하는 상태로 재설정해야 했습니다. Turborepo 2.4에서는 다음을 포함하여 여러분이 만든 UI 선택 중 일부를 유지합니다:"
  }, {
    "heading": "지속적인-기본-설정",
    "content": "이전에 선택한 작업이 다음에 turbo를 실행할 때 미리 선택됩니다. 위아래 화살표 키를 쉬게 해주세요."
  }, {
    "heading": "지속적인-기본-설정",
    "content": "아래에 설명된 대로 작업 목록 표시 여부"
  }, {
    "heading": "지속적인-기본-설정",
    "content": "아래에 설명된 대로 작업 선택 고정"
  }, {
    "heading": "지속적인-기본-설정",
    "content": "이러한 기본 설정을 유지하면 turbo 호출 전반에 걸쳐 더 원활한 경험을 제공하여 이전 turbo 실행의 상태로 UI를 복원합니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "작업 및 로그 작업을 더 쉽게 할 수 있도록 터미널 UI에 더 많은 기능을 추가했습니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "h로 작업 목록 토글: 작업 중 하나에 집중하는 경우가 많으므로 항상 작업 목록을 볼 필요가 없습니다. h 키를 눌러 작업 목록을 표시하고 숨깁니다. 이 기능은 위에 설명된 대로 지속적인 기본 설정입니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "c로 로그 복사: 마우스로 로그 세트를 강조 표시한 후 c를 눌러 시스템 클립보드에 로그를 복사합니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "j 및 k로 작업 선택: 이제 ↑ 및 ↓ 외에도 j 및 k를 사용하여 작업 목록을 순환할 수 있습니다. Vim 사용자 여러분, 기뻐하세요."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "p로 선택한 작업 고정: 작업을 선택하면 \"핀\"이 설정되어 작업이 상태를 변경하는 동안에도 계속 선택됩니다. p를 눌러 핀을 해제하거나 호버 중인 작업을 고정할 수 있습니다. 이 기능은 위에 설명된 대로 지속적인 기본 설정입니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "u 및 d로 로그 스크롤: 이제 u를 눌러 로그를 위로 스크롤하고 d를 눌러 로그를 아래로 스크롤할 수 있습니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "m로 자세히 알아보기: m를 누르면 사용 가능한 모든 키 바인딩을 나열하는 팝업이 표시됩니다."
  }, {
    "heading": "새로운-키-바인딩",
    "content": "자세한 내용은 문서를 방문하세요."
  }, {
    "heading": "watch-mode-캐싱-experimental",
    "content": "Watch Mode는 Task Graph에 따라 작업을 다시 실행하는 monorepo 인식 감시자입니다. 이를 통해 많은 작고 덜 강력한 감시자 스크립트가 아닌 단일의 전역적이고 의존성을 인식하는 감시자를 활용하여 monorepo에서 작업하는 새로운 방법을 제공합니다."
  }, {
    "heading": "watch-mode-캐싱-experimental",
    "content": "이번 릴리스에서는 Watch Mode에 실험적 기능으로 캐싱을 추가합니다. 활성화하려면 --experimental-write-cache 플래그를 사용하세요:"
  }, {
    "heading": "watch-mode-캐싱-experimental",
    "content": "Watch Mode에 대해 자세히 알아보려면 문서를 방문하세요."
  }, {
    "heading": "순환-의존성-권장-사항",
    "content": "순환 의존성은 Turborepo의 Task Graph에서 비결정적 순환을 생성하는 패키지 그래프의 루프입니다. 그러나 작업 그래프에 루프가 있는 경우 Turborepo는 두 작업이 서로 의존하기 때문에 어떤 작업이 먼저 오는지 결정할 수 없습니다."
  }, {
    "heading": "순환-의존성-권장-사항",
    "content": "monorepo에서 Turborepo를 채택하는 동안 Turborepo가 이전 작업 실행기보다 더 정교하고 빠른 Task Graph를 생성하므로 순환 의존성을 발견할 수 있습니다. 이전에는 Turborepo가 저장소의 Package Graph에 존재하는 순환에 관련된 모든 패키지를 단순히 나열했습니다. 이제 Turborepo는 그래프의 순환을 제거하기 위해 끊어야 하는 의존성 관계를 포함합니다."
  }, {
    "heading": "순환-의존성-권장-사항",
    "content": "아래 터미널 출력의 이전과 이후를 비교하세요:"
  }, {
    "heading": "node_modules의-schemajson",
    "content": "schema.json 파일은 JSON 파일에 대한 편집기에서 자동 완성 및 유효성 검사를 제공합니다. https://turborepo.com/schema.json에 호스팅된 turbo.json용 schema.json의 웹 액세스 가능 버전이 있지만 일부 개발자는 설치된 turbo 버전과 동기화하기 위해 node_modules에서 파일을 가져오는 것을 선호합니다."
  }, {
    "heading": "node_modules의-schemajson",
    "content": "이번 릴리스부터 패키지 관리자의 설치 명령을 실행한 후 node_modules에서 schema.json을 사용할 수 있습니다:"
  }, {
    "heading": "node_modules의-schemajson",
    "content": "저장소의 루트에 turbo를 설치하는 것이 좋으므로 스키마 경로는 저장소 루트의\nnode_modules를 가리켜야 합니다. 패키지\n구성에서는\n../../node_modules/turbo/schema.json과 같은 경로를 사용해야 할 수 있습니다."
  }, {
    "heading": "node_modules의-schemajson",
    "content": "자세한 정보는 문서를 방문하세요."
  }, {
    "heading": "eslint-flat-config-지원",
    "content": "Turborepo 2.4는 2024년 10월 5일 ESLint v8의 수명 종료에 따라 eslint-config-turbo 및 eslint-plugin-turbo에서 ESLint v9에 대한 지원을 도입합니다."
  }, {
    "heading": "eslint-flat-config-지원",
    "content": "구성 및 플러그인은 ESLint v8을 여전히 사용하는 사용자를 위해 원활한 전환을 보장하기 위해 이전 버전과 호환됩니다."
  }, {
    "heading": "eslint-flat-config-지원",
    "content": "자세한 정보는 문서를 방문하세요."
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(link): add --yes and --scope flags to link\n(#9466)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat(prune): add --use-gitignore flag (#9797)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat: remote cache upload timeout (#9491)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat: update eslint-config-turbo to support ESLint Flat Config. (#9502)"
  }, {
    "heading": "기타-변경-사항",
    "content": "feat: respect gitignore during turbo prune (#9711)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(windows): fix env var glob casing (#9429)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cache): allow force to override any cache settings (#9454)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cache): no longer let remoteCache.enable override force (#9684)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cache): suggest proper --cache flag for --remote-cache-read-only (#9701)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cache): avoid warning if TURBO_FORCE, TURBO_REMOTE_ONLY, and TURBO_CACHE (#9704)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(affected): consider both source and destination as changed (#9422)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(env): add DISPLAY to default pass through (#9511)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(env): allow passThroughEnv to negate built ins and globalPassThroughEnv (#9680)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(cli): error on out of place run args (#9445)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(daemon): limit number of git children (#9572)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(examples): create-turbo dependencies with npm (#9580)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(examples): add missing ESLint dependency (#9640)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(examples): basic generator (#9687)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(examples): bug in design system example (#9284)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(example): remove conflict css property from with-tailwind example (#9816)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(berry): add yarn berry support for built dependencies meta when pruning (#9605)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(watch): watch command require tasks argument (#9598)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(watch): fix output text when no tasks are provided (#9612)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(watch): correctly derive opts from watch mode args (#9761)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(package-manager): allow custom URL for packageManager version (#9624)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(repository): honour handleTransparentWorkspaces setting in Yarn/Berry (#9626)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(prune): fix Yarn1 entries getting merged erroneously (#9627)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(create-turbo): correct repo name (#9708)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(tui): avoid zombie process on clipboard write failure (#9713)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix(filewatcher): handle removed directories #8800 (#9406)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: correct TUI vim binds direction (#9529)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: packages listed twice in watch mode (#9644)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: respect output mode 'none' even when caching is disabled (#9670)"
  }, {
    "heading": "기타-변경-사항",
    "content": "fix: upgrade the turbo package in Yarn 4 (#8076)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: changesets configuration (#9325)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: clarify output globs relativeness. (#9449)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add TURBO_CACHE to System Environment Variables. (#9450)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(turbopack): Add incremental-computation page, intended to replace core-concepts page (#9456)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(turbopack): Remove old core-concepts page (#9457)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: small stylistic change for footnote. (#9451)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: improve clarity on --cache. (#9489)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mark --no-cache and --remote-only as deprecated. (#9488)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: describe using a custom URL with create-turbo. (#9507)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix formatting on /docs/getting-started/installation (#9509)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix formatting on /docs/getting-started/installation (#9514)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update ESLint documentation with ESLint v9 (#9515)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: options one-pager (#9533)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(typo): fix typo on turbo-ignore page (#9576)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: clarify default daemon usage (#9566)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: provide reasoning on why Turborepo doesn't support nested workspaces (#9586)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update CONTRIBUTING.md (#9590)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: change path of options overview page (#9600)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: remove old options page (#9601)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add community implementations of Remote Cache (#9631)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix CONTRIBUTING.md typo (#9637)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mention capnp in the dependencies (#9643)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add missing api folder in turbo prune api --docker example (#9648)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add missing apps folder in prune command reference (#9658)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: correct Bun support status (#9664)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mention module resolution differences for package managers (#9665)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(errors): improve error message for recursive calls (#9650)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: guide for Playwright (#9662)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mention --graph on graphs page (#9661)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: document creating packages with framework bindings (#9222)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add note about packaging patterns (#9673)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: guide for shadcn/ui (#9675)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add link to shadcn/ui page (#9678)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: mention free remote caching earlier on page (#9688)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: typo fix (#9690)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs(fix): correct line highlighting by removing extra comma (#9696)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: add community-built Run Summaries web viewer (#9679)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: edits for Prisma guide (#9682)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update docs to use correct changeset dir (#9722)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: update CONTRIBUTING.md (#9759)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: migration guide for users coming from Nx (#9762)"
  }, {
    "heading": "기타-변경-사항",
    "content": "docs: fix typo (#9814)"
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: Anthony, Chris, Dimitri, Nicholas, 그리고 Tom."
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 참여 방법을 알아보려면 커뮤니티 페이지를 방문하세요."
  }, {
    "heading": "감사의-말-및-커뮤니티",
    "content": "또한 이번 Turborepo 릴리스에 기여해 주신 모든 분들께 감사드립니다: @aaronccasanova, @AlvaroParker, @ankur-arch, @arosequist, @atimmer, @bgw, @bitttttten, @chaficnajjar, @codexshell, @eps1lon, @gianelli99, @glitched-w0rld, @JasonnnW3000, @jbrocksfellas, @jeremy-code, @jonathandsouza, @Juneezee, @kayumuzzaman, @krlvi, @maciej-ka, @ognevny, @olets, @pkerschbaum, @romanofski, @shivam-pawar, @takaebato, @tevem1207, @thebrubaker, @Tofandel, @trivikr, @yamz8, 그리고 @zsh77."
  }],
  "headings": [{
    "id": "boundaries-experimental",
    "content": "Boundaries Experimental"
  }, {
    "id": "터미널-ui-개선",
    "content": "터미널 UI 개선"
  }, {
    "id": "지속적인-기본-설정",
    "content": "지속적인 기본 설정"
  }, {
    "id": "새로운-키-바인딩",
    "content": "새로운 키 바인딩"
  }, {
    "id": "watch-mode-캐싱-experimental",
    "content": "Watch Mode 캐싱 Experimental"
  }, {
    "id": "순환-의존성-권장-사항",
    "content": "순환 의존성 권장 사항"
  }, {
    "id": "node_modules의-schemajson",
    "content": "node_modules의 schema.json"
  }, {
    "id": "eslint-flat-config-지원",
    "content": "ESLint Flat Config 지원"
  }, {
    "id": "기타-변경-사항",
    "content": "기타 변경 사항"
  }, {
    "id": "감사의-말-및-커뮤니티",
    "content": "감사의 말 및 커뮤니티"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Tab, Tabs} from '#components/tabs';
import {Accordions, Accordion} from '#components/accordion';
import {ExperimentalBadge} from '#components/experimental-badge';
import {Kbd} from '#components/kbd';
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#boundaries-experimental",
  title: _jsxs(_Fragment, {
    children: ["Boundaries ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 2,
  url: "#터미널-ui-개선",
  title: _jsx(_Fragment, {
    children: "터미널 UI 개선"
  })
}, {
  depth: 3,
  url: "#지속적인-기본-설정",
  title: _jsx(_Fragment, {
    children: "지속적인 기본 설정"
  })
}, {
  depth: 3,
  url: "#새로운-키-바인딩",
  title: _jsx(_Fragment, {
    children: "새로운 키 바인딩"
  })
}, {
  depth: 2,
  url: "#watch-mode-캐싱-experimental",
  title: _jsxs(_Fragment, {
    children: ["Watch Mode 캐싱 ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 2,
  url: "#순환-의존성-권장-사항",
  title: _jsx(_Fragment, {
    children: "순환 의존성 권장 사항"
  })
}, {
  depth: 2,
  url: "#node_modules의-schemajson",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "node_modules"
    }), "의 ", _jsx("code", {
      children: "schema.json"
    })]
  })
}, {
  depth: 2,
  url: "#eslint-flat-config-지원",
  title: _jsx(_Fragment, {
    children: "ESLint Flat Config 지원"
  })
}, {
  depth: 2,
  url: "#기타-변경-사항",
  title: _jsx(_Fragment, {
    children: "기타 변경 사항"
  })
}, {
  depth: 2,
  url: "#감사의-말-및-커뮤니티",
  title: _jsx(_Fragment, {
    children: "감사의 말 및 커뮤니티"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.4"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, January 31st, 2025"
    }), "\n", _jsx(Authors, {
      authors: ['nicholasyang', 'anthonyshew', 'chrisolszewski']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.4는 저장소를 향상시키는 여러 개선 사항을 포함합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#boundaries-experimental",
          children: _jsxs(_components.strong, {
            children: ["Boundaries ", _jsx(ExperimentalBadge, {
              children: "Experimental"
            })]
          })
        }), ": Turborepo의 Boundaries 첫 번째 살펴보기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#terminal-ui-improvements",
          children: _jsx(_components.strong, {
            children: "터미널 UI 개선"
          })
        }), ": 지속적인 기본 설정 및 새로운 기능"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#watch-mode-caching-experimental",
          children: _jsxs(_components.strong, {
            children: ["Watch Mode 캐싱 ", _jsx(ExperimentalBadge, {
              children: "Experimental"
            })]
          })
        }), ": Watch Mode에서 더 빠르게 개발"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#circular-dependency-recommendations",
          children: _jsx(_components.strong, {
            children: "순환 의존성 권장 사항"
          })
        }), ": 대규모 저장소에서 Turborepo를 더 쉽게 채택"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#schemajson-in-node_modules",
          children: _jsxs(_components.strong, {
            children: [_jsx(_components.code, {
              children: "node_modules"
            }), "의 ", _jsx(_components.code, {
              children: "schema.json"
            })]
          })
        }), ": 저장소 내에서 버전화된 구성 유효성 검사"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#eslint-flat-config-support",
          children: _jsx(_components.strong, {
            children: "ESLint Flat Config 지원"
          })
        }), ": ESLint v9용으로 업데이트된 ", _jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " 및 ", _jsx(_components.code, {
          children: "eslint-plugin-turbo"
        })]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), "를 실행하여 지금 업그레이드하거나 ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "로 시작하세요."]
    }), "\n", _jsxs(_components.h2, {
      id: "boundaries-experimental",
      children: ["Boundaries ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 패키지 관리자 Workspaces 위에 구축되어 저장소의 작업 캐싱을 결정하는 일부로 생태계 규칙에 의존합니다. 그러나 이를 위해서는 저장소의 모든 개발자가 이러한 규칙을 알고 준수해야 합니다."
    }), "\n", _jsx(_components.p, {
      children: "Boundaries는 이러한 모범 사례가 따라지지 않는 저장소의 위치를 포착하는 실험적 기능입니다. 이를 통해 캐싱이 더 안전해지고 저장소가 향후 Turborepo 기능을 안전하게 사용할 준비가 되도록 보장합니다."
    }), "\n", _jsx(_components.p, {
      children: "다음을 사용하여 오늘 시도해 보세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " boundaries"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Boundaries의 이 초기 반복에는 두 가지 유형의 monorepo 실수를 찾는 것이 포함됩니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "패키지 디렉토리 외부의 파일 가져오기"
      }), "\n", _jsx(_components.li, {
        children: "의존성에 지정되지 않은 패키지 가져오기"
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      title: "Boundaries RFC",
      children: _jsxs(_components.p, {
        children: ["이러한 내장 진단뿐만 아니라 사용자 정의 Boundaries에 대한 제안이 포함된\n", _jsx(_components.a, {
          href: "https://github.com/vercel/turborepo/discussions/9435",
          children: "Boundaries RFC"
        }), "에 대한\n여러분의 피드백을 기대합니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 내용은 ", _jsx(_components.a, {
        href: "/docs/reference/boundaries",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "터미널-ui-개선",
      children: "터미널 UI 개선"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/blog/turbo-2-0",
        children: "Turborepo 2.0"
      }), "에서 처음 출시된 터미널 UI를 계속 반복 개선했습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "지속적인-기본-설정",
      children: "지속적인 기본 설정"
    }), "\n", _jsxs(_components.p, {
      children: ["이전 버전의 Turborepo에서는 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 실행할 때마다 터미널 UI를 원하는 상태로 재설정해야 했습니다. Turborepo 2.4에서는 다음을 포함하여 여러분이 만든 UI 선택 중 일부를 유지합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["이전에 선택한 작업이 다음에 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 실행할 때 미리 선택됩니다. 위아래 화살표 키를 쉬게 해주세요."]
      }), "\n", _jsx(_components.li, {
        children: "아래에 설명된 대로 작업 목록 표시 여부"
      }), "\n", _jsx(_components.li, {
        children: "아래에 설명된 대로 작업 선택 고정"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 기본 설정을 유지하면 ", _jsx(_components.code, {
        children: "turbo"
      }), " 호출 전반에 걸쳐 더 원활한 경험을 제공하여 이전 ", _jsx(_components.code, {
        children: "turbo"
      }), " 실행의 상태로 UI를 복원합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "새로운-키-바인딩",
      children: "새로운 키 바인딩"
    }), "\n", _jsx(_components.p, {
      children: "작업 및 로그 작업을 더 쉽게 할 수 있도록 터미널 UI에 더 많은 기능을 추가했습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "h"
          }), "로 작업 목록 토글"]
        }), ": 작업 중 하나에 집중하는 경우가 많으므로 항상 작업 목록을 볼 필요가 없습니다. ", _jsx(Kbd, {
          children: "h"
        }), " 키를 눌러 작업 목록을 표시하고 숨깁니다. 이 기능은 위에 설명된 대로 지속적인 기본 설정입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "c"
          }), "로 로그 복사"]
        }), ": 마우스로 로그 세트를 강조 표시한 후 ", _jsx(Kbd, {
          children: "c"
        }), "를 눌러 시스템 클립보드에 로그를 복사합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "j"
          }), " 및 ", _jsx(Kbd, {
            children: "k"
          }), "로 작업 선택"]
        }), ": 이제 ", _jsx(Kbd, {
          children: "↑"
        }), " 및 ", _jsx(Kbd, {
          children: "↓"
        }), " 외에도 ", _jsx(Kbd, {
          children: "j"
        }), " 및 ", _jsx(Kbd, {
          children: "k"
        }), "를 사용하여 작업 목록을 순환할 수 있습니다. Vim 사용자 여러분, 기뻐하세요."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "p"
          }), "로 선택한 작업 고정"]
        }), ": 작업을 선택하면 \"핀\"이 설정되어 작업이 상태를 변경하는 동안에도 계속 선택됩니다. ", _jsx(Kbd, {
          children: "p"
        }), "를 눌러 핀을 해제하거나 호버 중인 작업을 고정할 수 있습니다. 이 기능은 위에 설명된 대로 지속적인 기본 설정입니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "u"
          }), " 및 ", _jsx(Kbd, {
            children: "d"
          }), "로 로그 스크롤"]
        }), ": 이제 ", _jsx(Kbd, {
          children: "u"
        }), "를 눌러 로그를 위로 스크롤하고 ", _jsx(Kbd, {
          children: "d"
        }), "를 눌러 로그를 아래로 스크롤할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(Kbd, {
            children: "m"
          }), "로 자세히 알아보기"]
        }), ": ", _jsx(Kbd, {
          children: "m"
        }), "를 누르면 사용 가능한 모든 키 바인딩을 나열하는 팝업이 표시됩니다."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications",
        children: "자세한 내용은 문서를 방문하세요."
      })
    }), "\n", _jsxs(_components.h2, {
      id: "watch-mode-캐싱-experimental",
      children: ["Watch Mode 캐싱 ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/developing-applications#watch-mode",
        children: "Watch Mode"
      }), "는 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), "에 따라 작업을 다시 실행하는 monorepo 인식 감시자입니다. 이를 통해 많은 작고 덜 강력한 감시자 스크립트가 아닌 단일의 전역적이고 의존성을 인식하는 감시자를 활용하여 monorepo에서 작업하는 새로운 방법을 제공합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이번 릴리스에서는 Watch Mode에 실험적 기능으로 캐싱을 추가합니다. 활성화하려면 ", _jsx(_components.code, {
        children: "--experimental-write-cache"
      }), " 플래그를 사용하세요:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " watch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --experimental-write-cache"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Watch Mode에 대해 자세히 알아보려면 ", _jsx(_components.a, {
        href: "/docs/reference/watch",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "순환-의존성-권장-사항",
      children: "순환 의존성 권장 사항"
    }), "\n", _jsxs(_components.p, {
      children: ["순환 의존성은 Turborepo의 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), "에서 비결정적 순환을 생성하는 패키지 그래프의 루프입니다. 그러나 작업 그래프에 루프가 있는 경우 Turborepo는 두 작업이 서로 의존하기 때문에 어떤 작업이 먼저 오는지 결정할 수 없습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["monorepo에서 Turborepo를 채택하는 동안 Turborepo가 이전 작업 실행기보다 더 정교하고 빠른 Task Graph를 생성하므로 순환 의존성을 발견할 수 있습니다. 이전에는 Turborepo가 저장소의 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "에 존재하는 순환에 관련된 모든 패키지를 단순히 나열했습니다. 이제 Turborepo는 그래프의 순환을 제거하기 위해 끊어야 하는 의존성 관계를 포함합니다."]
    }), "\n", _jsx(_components.p, {
      children: "아래 터미널 출력의 이전과 이후를 비교하세요:"
    }), "\n", _jsxs(Tabs, {
      items: ["After", "Before"],
      children: [_jsx(Tab, {
        value: "After",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  × Invalid package dependency graph:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶ Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     @repo/logger, blog, storefront, @repo/ui"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     The cycle can be broken by removing any of these sets of dependencies:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     { @repo/ui -> @repo/logger, @repo/ui -> storefront }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     { @repo/logger -> @repo/ui, @repo/ui -> storefront }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶   api, admin"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        The cycle can be broken by removing any of these sets of dependencies:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        { admin -> api }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        { api -> admin }"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "Before",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  × Invalid package dependency graph: Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     @repo/logger, storefront, @repo/ui, blog"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  │     api, admin"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "  ╰─▶ Cyclic dependency detected:"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        @repo/logger, storefront, @repo/ui, blog"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  children: "        api, admin"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.h2, {
      id: "node_modules의-schemajson",
      children: [_jsx(_components.code, {
        children: "node_modules"
      }), "의 ", _jsx(_components.code, {
        children: "schema.json"
      })]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "schema.json"
      }), " 파일은 JSON 파일에 대한 편집기에서 자동 완성 및 유효성 검사를 제공합니다. ", _jsx(_components.a, {
        href: "https://turborepo.com/schema.json",
        children: _jsx(_components.code, {
          children: "https://turborepo.com/schema.json"
        })
      }), "에 호스팅된 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "용 ", _jsx(_components.code, {
        children: "schema.json"
      }), "의 웹 액세스 가능 버전이 있지만 일부 개발자는 설치된 ", _jsx(_components.code, {
        children: "turbo"
      }), " 버전과 동기화하기 위해 ", _jsx(_components.code, {
        children: "node_modules"
      }), "에서 파일을 가져오는 것을 선호합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이번 릴리스부터 패키지 관리자의 설치 명령을 실행한 후 ", _jsx(_components.code, {
        children: "node_modules"
      }), "에서 ", _jsx(_components.code, {
        children: "schema.json"
      }), "을 사용할 수 있습니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"$schema\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"./node_modules/turbo/schema.json\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      title: "node_modules 위치",
      children: _jsxs(_components.p, {
        children: ["저장소의 루트에 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 설치하는 것이 좋으므로 스키마 경로는 저장소 루트의\n", _jsx(_components.code, {
          children: "node_modules"
        }), "를 가리켜야 합니다. ", _jsx(_components.a, {
          href: "/docs/reference/package-configurations",
          children: "패키지\n구성"
        }), "에서는\n", _jsx(_components.code, {
          children: "../../node_modules/turbo/schema.json"
        }), "과 같은 경로를 사용해야 할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 정보는 ", _jsx(_components.a, {
        href: "/docs/getting-started/editor-integration#sourcing-from-node_modules",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "eslint-flat-config-지원",
      children: "ESLint Flat Config 지원"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo 2.4는 2024년 10월 5일 ESLint v8의 수명 종료에 따라 ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " 및 ", _jsx(_components.code, {
        children: "eslint-plugin-turbo"
      }), "에서 ESLint v9에 대한 지원을 도입합니다."]
    }), "\n", _jsxs(Tabs, {
      items: ["eslint-config-turbo", "eslint-plugin-turbo"],
      children: [_jsx(Tab, {
        value: "eslint-config-turbo",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/eslint-config/index.js",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " turboConfig "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'eslint-config-turbo/flat'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  ..."
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "turboConfig"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "  // Other configuration"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "];"
                })
              })]
            })
          })
        })
      }), _jsx(Tab, {
        value: "eslint-plugin-turbo",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./packages/eslint-config/index.js",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "import"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " turbo "
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "from"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'eslint-plugin-turbo'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: ";"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: " "
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "export"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: " default"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  {"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    plugins"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    rules"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "      'turbo/no-undeclared-env-vars'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " 'error'"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-comment)",
                    "--shiki-dark": "var(--shiki-token-comment)"
                  },
                  children: "  // Other configuration"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "];"
                })
              })]
            })
          })
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "구성 및 플러그인은 ESLint v8을 여전히 사용하는 사용자를 위해 원활한 전환을 보장하기 위해 이전 버전과 호환됩니다."
    }), "\n", _jsxs(_components.p, {
      children: ["자세한 정보는 ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: "문서를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "기타-변경-사항",
      children: "기타 변경 사항"
    }), "\n", _jsxs(Accordions, {
      children: [_jsx(Accordion, {
        title: "Features (5)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["feat(link): add ", _jsx(_components.code, {
              children: "--yes"
            }), " and ", _jsx(_components.code, {
              children: "--scope"
            }), " flags to ", _jsx(_components.code, {
              children: "link"
            }), "\n(", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9466",
              children: "#9466"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat(prune): add ", _jsx(_components.code, {
              children: "--use-gitignore"
            }), " flag (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9797",
              children: "#9797"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: remote cache upload timeout (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9491",
              children: "#9491"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: update ", _jsx(_components.code, {
              children: "eslint-config-turbo"
            }), " to support ESLint Flat Config. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9502",
              children: "#9502"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["feat: respect gitignore during turbo prune (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9711",
              children: "#9711"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Fixes (29)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["fix(windows): fix env var glob casing (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9429",
              children: "#9429"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): allow force to override any cache settings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9454",
              children: "#9454"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): no longer let remoteCache.enable override force (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9684",
              children: "#9684"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): suggest proper --cache flag for --remote-cache-read-only (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9701",
              children: "#9701"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cache): avoid warning if TURBO_FORCE, TURBO_REMOTE_ONLY, and TURBO_CACHE (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9704",
              children: "#9704"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(affected): consider both source and destination as changed (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9422",
              children: "#9422"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(env): add DISPLAY to default pass through (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9511",
              children: "#9511"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(env): allow ", _jsx(_components.code, {
              children: "passThroughEnv"
            }), " to negate built ins and ", _jsx(_components.code, {
              children: "globalPassThroughEnv"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9680",
              children: "#9680"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(cli): error on out of place run args (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9445",
              children: "#9445"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(daemon): limit number of git children (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9572",
              children: "#9572"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): create-turbo dependencies with npm (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9580",
              children: "#9580"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): add missing ESLint dependency (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9640",
              children: "#9640"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): basic generator (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9687",
              children: "#9687"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(examples): bug in design system example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9284",
              children: "#9284"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(example): remove conflict css property from with-tailwind example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9816",
              children: "#9816"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(berry): add yarn berry support for built dependencies meta when pruning (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9605",
              children: "#9605"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): watch command require tasks argument (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9598",
              children: "#9598"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): fix output text when no tasks are provided (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9612",
              children: "#9612"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(watch): correctly derive opts from watch mode args (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9761",
              children: "#9761"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(package-manager): allow custom URL for ", _jsx(_components.code, {
              children: "packageManager"
            }), " version (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9624",
              children: "#9624"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(repository): honour handleTransparentWorkspaces setting in Yarn/Berry (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9626",
              children: "#9626"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(prune): fix Yarn1 entries getting merged erroneously (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9627",
              children: "#9627"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(create-turbo): correct repo name (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9708",
              children: "#9708"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(tui): avoid zombie process on clipboard write failure (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9713",
              children: "#9713"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix(filewatcher): handle removed directories #8800 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9406",
              children: "#9406"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: correct TUI vim binds direction (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9529",
              children: "#9529"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: packages listed twice in watch mode (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9644",
              children: "#9644"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: respect output mode 'none' even when caching is disabled (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9670",
              children: "#9670"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["fix: upgrade the turbo package in Yarn 4 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/8076",
              children: "#8076"
            }), ")"]
          }), "\n"]
        })
      }), _jsx(Accordion, {
        title: "Documentation (42)",
        children: _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: ["docs: changesets configuration (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9325",
              children: "#9325"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify output globs relativeness. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9449",
              children: "#9449"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add ", _jsx(_components.code, {
              children: "TURBO_CACHE"
            }), " to System Environment Variables. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9450",
              children: "#9450"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(turbopack): Add incremental-computation page, intended to replace core-concepts page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9456",
              children: "#9456"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(turbopack): Remove old core-concepts page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9457",
              children: "#9457"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: small stylistic change for footnote. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9451",
              children: "#9451"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: improve clarity on ", _jsx(_components.code, {
              children: "--cache"
            }), ". (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9489",
              children: "#9489"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mark ", _jsx(_components.code, {
              children: "--no-cache"
            }), " and ", _jsx(_components.code, {
              children: "--remote-only"
            }), " as deprecated. (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9488",
              children: "#9488"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: describe using a custom URL with ", _jsx(_components.code, {
              children: "create-turbo"
            }), ". (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9507",
              children: "#9507"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix formatting on ", _jsx(_components.code, {
              children: "/docs/getting-started/installation"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9509",
              children: "#9509"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix formatting on ", _jsx(_components.code, {
              children: "/docs/getting-started/installation"
            }), " (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9514",
              children: "#9514"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update ESLint documentation with ESLint v9 (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9515",
              children: "#9515"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: options one-pager (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9533",
              children: "#9533"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(typo): fix typo on turbo-ignore page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9576",
              children: "#9576"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: clarify default daemon usage (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9566",
              children: "#9566"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: provide reasoning on why Turborepo doesn't support nested workspaces (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9586",
              children: "#9586"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update CONTRIBUTING.md (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9590",
              children: "#9590"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: change path of options overview page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9600",
              children: "#9600"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: remove old options page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9601",
              children: "#9601"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add community implementations of Remote Cache (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9631",
              children: "#9631"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix CONTRIBUTING.md typo (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9637",
              children: "#9637"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention capnp in the dependencies (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9643",
              children: "#9643"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add missing ", _jsx(_components.code, {
              children: "api"
            }), " folder in ", _jsx(_components.code, {
              children: "turbo prune api --docker"
            }), " example (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9648",
              children: "#9648"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add missing ", _jsx(_components.code, {
              children: "apps"
            }), " folder in ", _jsx(_components.code, {
              children: "prune"
            }), " command reference (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9658",
              children: "#9658"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: correct Bun support status (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9664",
              children: "#9664"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention module resolution differences for package managers (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9665",
              children: "#9665"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(errors): improve error message for recursive calls (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9650",
              children: "#9650"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: guide for Playwright (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9662",
              children: "#9662"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention --graph on graphs page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9661",
              children: "#9661"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: document creating packages with framework bindings (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9222",
              children: "#9222"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add note about packaging patterns (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9673",
              children: "#9673"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: guide for shadcn/ui (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9675",
              children: "#9675"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add link to shadcn/ui page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9678",
              children: "#9678"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: mention free remote caching earlier on page (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9688",
              children: "#9688"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: typo fix (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9690",
              children: "#9690"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs(fix): correct line highlighting by removing extra comma (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9696",
              children: "#9696"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: add community-built Run Summaries web viewer (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9679",
              children: "#9679"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: edits for Prisma guide (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9682",
              children: "#9682"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update docs to use correct changeset dir (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9722",
              children: "#9722"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: update CONTRIBUTING.md (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9759",
              children: "#9759"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: migration guide for users coming from Nx (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9762",
              children: "#9762"
            }), ")"]
          }), "\n", _jsxs(_components.li, {
            children: ["docs: fix typo (", _jsx(_components.a, {
              href: "https://github.com/vercel/turborepo/pull/9814",
              children: "#9814"
            }), ")"]
          }), "\n"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "감사의-말-및-커뮤니티",
      children: "감사의 말 및 커뮤니티"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 핵심 팀을 포함한 모든 기여자들의 결합된 작업의 결과입니다: ", _jsx(_components.a, {
        href: "https://github.com/anthonyshew",
        children: "Anthony"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/chris-olszewski",
        children: "Chris"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/dimitropoulos",
        children: "Dimitri"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/NicholasLYang",
        children: "Nicholas"
      }), ", 그리고 ", _jsx(_components.a, {
        href: "https://github.com/tknickman",
        children: "Tom"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo를 여러분의 빌드 도구로 만들어 주시는 지속적인 지원, 피드백 및 협력에 감사드립니다. 참여 방법을 알아보려면 ", _jsx(_components.a, {
        href: "/docs/community",
        children: "커뮤니티 페이지를 방문하세요"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "또한 이번 Turborepo 릴리스에 기여해 주신 모든 분들께 감사드립니다: @aaronccasanova, @AlvaroParker, @ankur-arch, @arosequist, @atimmer, @bgw, @bitttttten, @chaficnajjar, @codexshell, @eps1lon, @gianelli99, @glitched-w0rld, @JasonnnW3000, @jbrocksfellas, @jeremy-code, @jonathandsouza, @Juneezee, @kayumuzzaman, @krlvi, @maciej-ka, @ognevny, @olets, @pkerschbaum, @romanofski, @shivam-pawar, @takaebato, @tevem1207, @thebrubaker, @Tofandel, @trivikr, @yamz8, 그리고 @zsh77."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
